// extracted by mini-css-extract-plugin
export default {"card":"RedirectConfirmation_card__x1flO","destination":"RedirectConfirmation_destination__gpn-g"};